import Toast from "../../common/components/ui/toast";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableRepossession from "./components/TableRepossession";

function RepossessionRegisterage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableRepossession />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default RepossessionRegisterage;
